export default function getCurrentScrollY() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (el) {
    return el.scrollTop;
  }

  return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}